import { render, staticRenderFns } from "./HeaderHomeEight.vue?vue&type=template&id=228476a3&scoped=true"
import script from "./HeaderHomeEight.vue?vue&type=script&lang=js"
export * from "./HeaderHomeEight.vue?vue&type=script&lang=js"
import style0 from "./HeaderHomeEight.vue?vue&type=style&index=0&id=228476a3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228476a3",
  null
  
)

export default component.exports